import { ProductHTTP } from '@/http'
import { RegXUtils, TOKEN } from '@/utils'
import { ProductViewModel } from '@/view-models'
import { ChangePriceView } from '../views/change-price.view'
import { ToggleAddonView } from '../views/toggle-addon.view'

export const setupProductConfiguration = (): void => {
  const cartProductConfiguration = document.querySelectorAll<HTMLElement>(
    '.js-cart-product-configuration'
  )

  const productHttp = new ProductHTTP(new RegXUtils())
  const productViewModel = new ProductViewModel(productHttp)

  cartProductConfiguration.forEach((productWidget) => {
    if (!TOKEN) {
      throw new Error("Product Configuration Setup: Token isn't set")
    }

    const productModel = productViewModel.makeModel(productWidget, TOKEN)

    new ChangePriceView(productWidget, productModel, productViewModel)
    new ToggleAddonView(productWidget, productModel, productViewModel)
  })
}
